import React from "react";
import ColaboradoresApiClient from "../../api/colaboradores";
import useApi from "../useApi";
import OptionsSwal from "../../components/Swal/optionsSwal";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import { AppContext } from "../../contexts/AppContext";
import { formataData } from "../../helpers/mesesHelper";

export default function useFerias(uid) {
  const [ferias, setFerias] = React.useState([]);
  const [feriasModal, setFeriasModal] = React.useState(false);
  const [feriasValues, setFeriasValues] = React.useState({});
  const { session } = React.useContext(AppContext);

  const { request: getFeriasColaborador, data: feriasColaboradorResponse } =
    useApi(ColaboradoresApiClient.getFeriasColaborador);
  const { request: getFerias } = useApi(ColaboradoresApiClient.getFerias);
  const { request: apagarFerias } = useApi(ColaboradoresApiClient.apagarFerias);
  const putFeriasApi = useApi(ColaboradoresApiClient.putFerias);

  //Busca férias do colaborador ao renderizar tela
  React.useEffect(() => {
    if (!uid || !session?.empresa) return;
    getFeriasColaborador(session.empresa.replace(/E/gi, ""), uid);
  }, [getFeriasColaborador, session.empresa, uid]);

  //Define estado ao receber férias do colaborador
  React.useEffect(() => {
    if (!feriasColaboradorResponse) return;
    setFerias(() => [...feriasColaboradorResponse]);
  }, [feriasColaboradorResponse]);

  const excluirFerias = React.useCallback(
    async (feriasId) => {
      OptionsSwal({
        text: "Você tem certeza que deseja apagar estas férias?",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await apagarFerias(
            session.empresa.replace(/E/gi, ""),
            uid,
            feriasId
          );
          if (!response) return;
          getFeriasColaborador(session.empresa.replace(/E/gi, ""), uid);
        }
      });
    },
    [apagarFerias, getFeriasColaborador, session.empresa, uid]
  );

  const getHint = React.useCallback((data) => {
    let data_admissao = new Date(data?.data_admissao);
    let hoje = new Date();

    let dataInicio = data?.periodo_disponivel_inicio;

    let admissaoYear = data_admissao.getFullYear();
    let currentYear = hoje.getFullYear();
    let dataInicioPeriodoAtivo = new Date(dataInicio);
    dataInicioPeriodoAtivo = new Date(
      dataInicioPeriodoAtivo.getFullYear(),
      dataInicioPeriodoAtivo.getMonth(),
      dataInicioPeriodoAtivo.getDate() + 1
    );
    let hintTexto = "";

    for (let year = admissaoYear; year <= currentYear; year++) {
      let dataInicioPeriodo = new Date(
        year,
        data_admissao.getMonth(),
        data_admissao.getDate() + 1
      );
      let dataFimPeriodo = new Date(
        year + 1,
        data_admissao.getMonth(),
        data_admissao.getDate()
      );

      if (
        dataFimPeriodo <= hoje &&
        (dataInicioPeriodo < dataInicioPeriodoAtivo ||
          dataInicio === "Indisponível")
      ) {
        hintTexto += `<s>${formataData(
          dataInicioPeriodo.toISOString().split("T")[0]
        )} até ${formataData(
          dataFimPeriodo.toISOString().split("T")[0]
        )}</s><br>`;
      } else if (
        dataFimPeriodo <= hoje &&
        dataInicioPeriodo >= dataInicioPeriodoAtivo
      ) {
        hintTexto += `${formataData(
          dataInicioPeriodo.toISOString().split("T")[0]
        )} até ${formataData(dataFimPeriodo.toISOString().split("T")[0])}<br>`;
      }

      if (
        (admissaoYear === currentYear && dataFimPeriodo > hoje) ||
        admissaoYear > currentYear
      ) {
        hintTexto += "Não há periodos aquisitivos disponíveis";
      }
    }

    return hintTexto;
  }, []);

  const togFeriasModal = React.useCallback(
    async (feriasId) => {
      const response = await getFerias(
        session.empresa.replace(/E/gi, ""),
        uid,
        feriasId
      );
      if (!response) return;
      const hint = getHint(response);
      setFeriasValues({ ...response, hint: hint });
      setFeriasModal(true);
    },
    [getFerias, getHint, session.empresa, uid]
  );

  const salvarFerias = React.useCallback(async () => {
    const formData = new FormData();
    formData.append(
      "periodo_aquisitivo_inicio",
      feriasValues?.periodo_disponivel_inicio
    );
    formData.append(
      "periodo_aquisitivo_fim",
      feriasValues?.periodo_disponivel_fim
    );
    formData.append(
      "periodo_ferias_inicio",
      feriasValues?.periodo_ferias_inicio
    );
    formData.append("periodo_ferias_fim", feriasValues?.periodo_ferias_fim);
    formData.append("dias_ferias", feriasValues?.dias_ferias);
    formData.append("data_pagamento", feriasValues?.data_pagamento);
    formData.append("valor", feriasValues?.valor);
    formData.append("arquivo", feriasValues?.novoArquivo);
    formData.append("vender_terco_ferias", feriasValues?.vender_terco_ferias);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await putFeriasApi.request(
      session.empresa.replace(/E/gi, ""),
      uid,
      feriasValues?.uid,
      formData
    );
    if (!response) return;
    setFeriasModal(false);
    getFeriasColaborador(session.empresa.replace(/E/gi, ""), uid);
  }, [feriasValues, getFeriasColaborador, putFeriasApi, session.empresa, uid]);

  return {
    ferias,
    feriasModal,
    setFeriasModal,
    feriasValues,
    setFeriasValues,
    togFeriasModal,
    excluirFerias,
    salvarFerias,
  };
}
